module.exports = __webpack_public_path__ + "img/tableOne.14526437.svg";